import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { Result, Spin } from 'antd'
import { useReducer, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import type { File } from 'react-pdf/dist/shared/types'

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

type PDFState =
  | {
      status: 'loading'
      pages?: undefined
    }
  | {
      status: 'success'
      pages: number
    }
  | {
      status: 'error'
      message: string
    }

type PDFAction = { type: 'onSuccess'; payload: pdfjs.PDFDocumentProxy } | { type: 'onError'; payload: Error }
const defaultState: PDFState = { status: 'loading' }
const reducer = (_state: PDFState, action: PDFAction): PDFState => {
  switch (action.type) {
    case 'onSuccess':
      return { status: 'success', pages: action.payload.numPages }
    case 'onError':
      return { status: 'error', message: action.payload.message }
  }
}

export const PdfViewer = ({ viewType = 'scroll', src }: { viewType?: 'scroll' | 'navigate'; src?: File }) => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const [pageNumber, setPageNumber] = useState(1)

  const shouldShowNav = viewType === 'navigate' && state.status === 'success'

  return (
    <Horizontal style={{ overflowY: 'scroll' }} horizontalCenter>
      <Document
        file={src}
        onLoadSuccess={(e) => dispatch({ type: 'onSuccess', payload: e })}
        onLoadError={(e) => dispatch({ type: 'onError', payload: e })}
      >
        {state.status === 'loading' ? (
          <Spin size='large' />
        ) : state.status === 'error' ? (
          <Result status='error' title='PDF could not be loaded' subTitle={state.message} />
        ) : viewType === 'navigate' ? (
          <Page pageNumber={pageNumber} renderAnnotationLayer={false} renderTextLayer={false} />
        ) : (
          Array.from(new Array(state.pages), (_, index) => (
            <Page
              renderTextLayer={false}
              renderAnnotationLayer={false}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
            />
          ))
        )}
      </Document>
      {shouldShowNav && (
        <div>
          <p>
            Page {pageNumber} of {state.pages}
          </p>
          <GraviButton disabled={pageNumber <= 1} onClick={() => setPageNumber((v) => v - 1)}>
            Previous
          </GraviButton>
          <GraviButton disabled={pageNumber >= state.pages} onClick={() => setPageNumber((v) => v + 1)}>
            Next
          </GraviButton>
        </div>
      )}
    </Horizontal>
  )
}
